<!-- STANDARD Modal Header -->
<div class="modal-header">
  <h3 class="modal-title">{{modalTitle}}</h3>
  <div class="header-actions">
    <i class="fa" 
       [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}" 
       style="margin-right: 10px; cursor: pointer;" 
       (click)="minimise=!minimise"></i>
    <i (click)="cancel()" class="fa fa-times" style="cursor: pointer;"></i>
  </div>
</div>

<!-- STANDARD Modal Body -->
<div class="modal-body no-body-scroll" [hidden]="minimise">
  
  @if (showFormLoader) {
<div class="formLoader">
    <i class="fa fa-spinner fa-spin gt-refresh"></i>
  </div>
}
  
  @if (!showFormLoader) {
<div>
    <table width="100%" class="custom-table">
      <tr>
        <td width="15%"></td>
        <td>
          <table class="table table-no-border form-inline custom-table">
            <tr>
              <td class="label-cell">Code Key:</td>
              <td class="value-cell">{{code_key}}</td>
            </tr>
            <tr>
              <td class="label-cell">Code Description:</td>
              <td class="value-cell">
                <input 
                  type="text" 
                  [(ngModel)]="code_desc" 
                  class="form-control input-sm" 
                  style="text-align: left; width:400px" 
                  maxlength="200"/>
              </td>
            </tr>
            <tr>
              <td class="label-cell">Code Short Description:</td>
              <td class="value-cell">
                <input 
                  type="text" 
                  [(ngModel)]="code_short_desc" 
                  class="form-control input-sm" 
                  style="text-align: left; width:200px" 
                  maxlength="100"/>
              </td>
            </tr>
            <tr>
              <td class="label-cell">Code Group:</td>
              <td class="value-cell">{{code_group}}</td>
            </tr>
            <tr>
              <td class="label-cell">From Year:</td>
              <td class="value-cell">
                <input 
                  [(ngModel)]="from_year" 
                  type="number" 
                  style="width:80px" 
                  class="form-control input-sm" 
                  (keydown)="$event.preventDefault()" 
                  placeholder="YYYY" 
                  min="1900" 
                  max="9999">
              </td>
            </tr>
            <tr>
              <td class="label-cell">To Year:</td>
              <td class="value-cell">
                <input 
                  [(ngModel)]="to_year" 
                  type="number" 
                  style="width:80px" 
                  class="form-control input-sm" 
                  (keydown)="$event.preventDefault()" 
                  placeholder="YYYY" 
                  min="1900" 
                  max="9999">
              </td>
            </tr>
            <tr>
              <td class="label-cell">Priority Order:</td>
              <td class="value-cell">
                <input 
                  type="number" 
                  style="width:80px" 
                  class="form-control input-sm" 
                  (keydown)="$event.preventDefault()" 
                  [(ngModel)]="priority_order" 
                  min="1">
              </td>
            </tr>
            <tr>
              <td class="label-cell">Created By:</td>
              <td class="value-cell">{{created_by}}</td>
            </tr>
            <tr>
              <td class="label-cell">Created On:</td>
              <td class="value-cell">{{created_on}}</td>
            </tr>
            <tr>
              <td class="label-cell">Updated By:</td>
              <td class="value-cell">{{updated_by}}</td>
            </tr>
            <tr>
              <td class="label-cell">Updated On:</td>
              <td class="value-cell">{{updated_on}}</td>
            </tr>
            <tr>
              <td class="label-cell">Is Display:</td>
              <td class="value-cell">
                Yes <input 
                      type="radio" 
                      name="is_display" 
                      [value]="'Y'" 
                      [checked]="is_display === 'Y'" 
                      (change)="onIsDisplayChange('Y')"/>
                No <input 
                      type="radio" 
                      name="is_display" 
                      [value]="'N'" 
                      [checked]="is_display === 'N'" 
                      (change)="onIsDisplayChange('N')"/>
              </td>
            </tr>
            <tr>
              <td class="label-cell">Code Display Description:</td>
              <td class="value-cell">
                <input 
                  type="text" 
                  [(ngModel)]="code_disp_desc" 
                  class="form-control input-sm" 
                  style="text-align: left; width:600px" 
                  maxlength="400"/>
              </td>
            </tr>
            <tr>
              <td class="label-cell">Is Default:</td>
              <td class="value-cell">
                Yes <input 
                      type="radio" 
                      name="is_default" 
                      [value]="'Y'" 
                      [checked]="is_default === 'Y'" 
                      (change)="onIsDefaultChange('Y')"/>
                No <input 
                      type="radio" 
                      name="is_default" 
                      [value]="'N'" 
                      [checked]="is_default === 'N'" 
                      (change)="onIsDefaultChange('N')"/>
              </td>
            </tr>
            <tr>
              <td class="label-cell">Code Long Description:</td>
              <td class="value-cell">
                <textarea 
                  type="text" 
                  width="100%" 
                  cols="77" 
                  maxlength="400" 
                  class="form-control input-xxlarge" 
                  [(ngModel)]="code_long_desc"></textarea>
              </td>
            </tr>
            <tr>
              <td class="label-cell">Row Type:</td>
              <td class="value-cell">
                <input 
                  type="text" 
                  [(ngModel)]="row_type" 
                  class="form-control input-sm" 
                  style="text-align: left; width:100px" 
                  maxlength="4"/>
              </td>
            </tr>
          </table>
        </td>
        <td width="15%"></td>
      </tr>
    </table>
  </div>
}
  
</div>

<!-- STANDARD Footer -->
<div class="modal-footer" [hidden]="minimise">
  <button 
    class="save-button" 
    type="button" 
    [disabled]="isSaveClicked" 
    (click)="save()">
    @if (crudLoading) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
}Save
  </button>
  <button 
    class="cancel-button" 
    type="button" 
    (click)="cancel()">Cancel</button>
</div>

